import { Box, Flex, Heading, Img, Text } from '@chakra-ui/react'
import { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'

import generic from '@service/generic'

const JobsPage: FC = () => {
  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        if (data.valor === 'false') {
          window.location.href = '/'
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <Helmet>
        <title>manutencao - SCL</title>
      </Helmet>
      <Box bg="white" h="100vh" overflowY="auto" color="gray.800">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          bg="white.600"
          borderRadius="8px"
          h="calc(100vh - 8px)"
          p={6}
        >
          <Img
            src="/assets/images/fundo2.jpeg"
            width={['60%', '60%', '50%']}
          ></Img>
          <Heading
            mb={5}
            textAlign="center"
            fontSize={['40px', '40px', '50px']}
            fontWeight="800"
            color="green.600"
          >
            Aguarde enquanto processamos <br></br> os dados para o SCL
          </Heading>
          <Text
            maxW="460px"
            fontSize="18px"
            textAlign="center"
            fontWeight="800"
            color="white"
          ></Text>
          <Text
            maxW="460px"
            fontSize="18px"
            textAlign="center"
            fontWeight="800"
            color="green.600"
          >
            Por enquanto, tente atualizar a página ou aguarde por alguns
            minutos.
          </Text>
        </Flex>
      </Box>
    </>
  )
}

export default JobsPage
